import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LogoLink } from "@/components/brand/BrpLogo";
import { Button } from "@/components/ui/button";
import { NAV } from "@/constants/testIds";
import { cn } from "@/lib/utils";

export const Header = ({ variant = "minimal" }) => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/legacy-league", label: "Legacy League" },
    { to: "/careers", label: "Careers" },
  ];

  return (
    <header
      className={cn(
        "sticky top-0 z-50 border-b",
        scrolled
          ? "bg-background/85 backdrop-blur border-border/70"
          : "bg-background/60 backdrop-blur border-transparent"
      )}
    >
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="flex h-16 items-center justify-between">
          <LogoLink testId={NAV.headerLogoLink} tone="dark" size={22} />

          {variant === "home" && (
            <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
              {navLinks.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className={cn(
                    "text-[13px] tracking-wide uppercase text-[hsl(var(--brp-ink-dim))] hover:text-[hsl(var(--brp-ink))] transition-colors",
                    pathname === l.to && "text-[hsl(var(--brp-ink))]"
                  )}
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          )}

          <div className="flex items-center gap-3">
            <Link to="/contact" data-testid={NAV.headerLetsTalk}>
              <Button
                variant="outline"
                className="rounded-full border-[hsl(var(--brp-orange))]/60 text-[hsl(var(--brp-orange))] hover:bg-[hsl(var(--brp-orange))]/10 hover:text-[hsl(var(--brp-orange))] px-5 tracking-wide uppercase text-[12px]"
              >
                Let’s Talk
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};
